import { Outlet } from 'react-router';

export function CampaignLayout() {
  return <Outlet />;
}
